import React from 'react';
import Box from '@mui/material/Box';
import PageTitle from '@/components/PageTitle/PageTitle';
import useHeader from '@/hooks/useHeader';

interface HeaderProps {
  isFullPage?: boolean;
  cta?: React.ReactNode;
  mb?: [number, number];
  pageTitle?: string;
  secondaryTitle?: React.ReactNode;
}

function Header({
  isFullPage = false,
  cta,
  pageTitle,
  secondaryTitle,
  mb = [18.75, 11.25],
}: HeaderProps) {
  const header = useHeader();

  return header || pageTitle ? (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      component="header"
      mb={isFullPage ? mb[0] : mb[1]}
      mt={isFullPage ? 11 : 0}
    >
      <Box display="flex" flexDirection="column" gap={4}>
        <PageTitle variant="default">{pageTitle ? pageTitle : header}</PageTitle>
        {secondaryTitle ? secondaryTitle : null}
      </Box>
      {cta ? cta : null}
    </Box>
  ) : null;
}

export default Header;
